module.exports = "<h1 class=\"error-number\">403</h1>\n\n<h2 class=\"semi-bold\">{{'Sorry but you cannot access this page' | translate}}</h2>\n\n<p>\n    {{'Maybe you do not have enough rights to access this page. Contact the administrator for more information.' | translate}} <a href=\"#\">{{'Report this?' | translate}}</a>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/pages/errors/page-forbidden/page-forbidden.page.html
// module id = ./libs/chassis-core/src/app/pages/errors/page-forbidden/page-forbidden.page.html
// module chunks = main